import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  TextField,
  Card,
  CardContent,
  Table,
  TableContainer,
  TableRow,
  TableBody,
  TableCell,
  TableHead,
  Paper,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  CircularProgress,
  IconButton,
  Divider,
  Tooltip,
  Stack,
  Chip,
  Tabs,
  Tab,
  alpha,
} from "@mui/material";
import AssessmentOutlinedIcon from "@mui/icons-material/AssessmentOutlined";
import ShowChartOutlinedIcon from "@mui/icons-material/ShowChartOutlined";
import TimelineOutlinedIcon from "@mui/icons-material/TimelineOutlined";
import CandlestickChartOutlinedIcon from "@mui/icons-material/CandlestickChartOutlined";
import InboxOutlinedIcon from "@mui/icons-material/InboxOutlined";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import EventOutlinedIcon from "@mui/icons-material/EventOutlined";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { TablePagination } from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import axios from "axios";
import { REPORTSERVICE, showToast, WEBSERVICE } from "../../CoreDataService";
import { useSelector } from "react-redux";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import { ContainedButton } from "../../Common/Buttons";

const Report = () => {
  // Spot

  const { btncolor, brokerMarkets } = useSelector((state) => state);
  const [spotReportList, setSpotReportList] = useState([]);
  const [selectedSpotReport, setSelectedSpotReport] = useState("");
  const [spotFinancialYearReportList, setSpotFinancialYearReportList] =
    useState([]);
  const [spotFinancialYear, setSpotFinancialYear] = useState([]);
  const [futureFinancialYear, setFutureFinancialYear] = useState([]);

  const [spotFrom, setSpotFrom] = useState(null);
  const [spotTo, setSpotTo] = useState(null);

  // Futures
  const [futuresReportList, setFuturesReportList] = useState([]);

  const [futuresReport, setFuturesReport] = useState("");
  const [futuresFrom, setFuturesFrom] = useState(null);
  const [futuresTo, setFuturesTo] = useState(null);

  // Options
  const [optionsReportList, setOptionsReportList] = useState([]);

  const [optionsReport, setOptionsReport] = useState("");
  const [optionsFrom, setOptionsFrom] = useState(null);
  const [optionsTo, setOptionsTo] = useState(null);

  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [selectYear, setSelectYear] = useState(new Date().getFullYear());
  const [country, setCountry] = useState(
    localStorage.getItem("userCountry").replace(/ /g, "_")
  ); // Change as needed
  const [datastore, setDatastore] = useState([]);
  const [fundingHeader, setFundingHeader] = useState([]);
  const [spotResultCount, setSpotResultCount] = useState(0);
  const [futureResultCount, setFutureResultCount] = useState(0);
  const [optionResultCount, setOptionResultCount] = useState(0);
  const [showExportButton, setShowExportButton] = useState(false);
  const [showSpotReport, setShowSpotReport] = useState(false);
  const [showOptionReport, setShowOptionReport] = useState(false);
  const [pagiArr, setPagiArr] = useState([]);
  const [pagiLength, setPagiLength] = useState(0);
  const [downloadUrl, setDownloadUrl] = useState("");
  const [urlForMailingReport, setUrlForMailingReport] = useState("");

  const [disclosureOpen, setDisclosureOpen] = useState(false);
  const [resultOpen, setResultOpen] = useState(false);

  const [currentPage, setCurrentPage] = useState(false);
  const [selectedFuturesReport, setSelectedFuturesReport] = useState(false);
  const [selectedYear, setSelectedYear] = useState(false);
  const [futuresYear, setFuturesYear] = useState(false);
  const [futuresPagination, setFuturesPagination] = useState(false);
  const [showFuturesExportButton, setShowFuturesExportButton] = useState(false);

  const [futuresResults, setFuturesResults] = useState([]);
  const [futuresHeader, setFuturesHeader] = useState([]);
  const [futuresDownloadUrl, setFuturesDownloadUrl] = useState("");
  const [optionsResults, setOptionsResults] = useState([]);
  const [optionsHeader, setOptionsHeader] = useState([]);
  const [optionsDownloadUrl, setOptionsDownloadUrl] = useState("");
  const [showFuturesReport, setShowFuturesReport] = useState(false);
  const [showOptionsReport, setShowOptionsReport] = useState(false);
  const [totalCount, setTotalCount] = useState(0);

  const [selectedOptionsReport, setSelectedOptionsReport] = useState(0);
  const [optionsYear, setOptionsYear] = useState(0);
  const [optionsPagination, setOptionsPagination] = useState(0);
  const [showOptionsExportButton, setShowOptionsExportButton] = useState(0);

  // Add the pagination state for each table
  const [spotPage, setSpotPage] = useState(0);
  const [spotRowsPerPage, setSpotRowsPerPage] = useState(25);

  const [futuresPage, setFuturesPage] = useState(0);
  const [futuresRowsPerPage, setFuturesRowsPerPage] = useState(25);

  const [optionsPage, setOptionsPage] = useState(0);
  const [optionsRowsPerPage, setOptionsRowsPerPage] = useState(5);

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmittingFutures, setIsSubmittingFutures] = useState(false);
  const [isSubmittingOptions, setIsSubmittingOptions] = useState(false);

  const [activeTab, setActiveTab] = useState("spot");

  // Handle page change
  const handleSpotPageChange = (event, newPage) => {
    setSpotPage(newPage);
    findData(newPage + 1);
  };

  const handleFuturesPageChange = (event, newPage) => {
    setFuturesPage(newPage);
    fetchFuturesReport(newPage + 1);
  };

  const handleOptionsPageChange = (event, newPage) => {
    setOptionsPage(newPage);
    fetchOptionsReport(newPage + 1);
  };

  // Handle rows per page change

  // Define the current slice of the data based on the pagination state

  const optionsRowsToDisplay = optionsResults.slice(
    optionsPage * optionsRowsPerPage,
    optionsPage * optionsRowsPerPage + optionsRowsPerPage
  );

  const headers = {
    "Content-Type": "application/json",
    authorization: "BEARER " + localStorage.getItem("access_token"),
  };
  const submitButtonStyle = {
    px: 4,
    height: "56px",
  };

  useEffect(() => {
    fetchReportData();
  }, []);

  const fetchReportData = () => {
    axios.get(`${REPORTSERVICE}viewAllMaster`, { headers }).then((res) => {
      setSpotReportList(res.data?.ResultSet?.body || []);
    });

    axios.get(`${REPORTSERVICE}financialYearList`, { headers }).then((res) => {
      setSpotFinancialYearReportList(res.data?.ResultSet?.body || []);
    });

    axios.get(`${REPORTSERVICE}futureReportMaster`, { headers }).then((res) => {
      setFuturesReportList(res.data || []);

      // You can map this later into the dropdown if needed
    });

    axios
      .get(`${REPORTSERVICE}optionsReportMaster`, { headers })
      .then((res) => {
        setOptionsReportList(res.data || []);

        // You can map this later into the dropdown if needed
      });
  };

  const handleReportDateDiff = (from, to) => {
    const d1 = dayjs(from, "D-M-YYYY");
    const d2 = dayjs(to, "D-M-YYYY");

    return d2.diff(d1, "day"); // Will return negative if to < from
  };

  const findData = async (pageNo) => {
    const usr = localStorage.getItem("uuid");
    const token = localStorage.getItem("access_token");
    const page = pageNo !== 0 ? pageNo : 1;

    let sumfdt, sumtdt;
    let fromDateStr = "",
      toDateStr = "";

    const reportArray = selectedSpotReport;

    // Log for debugging

    const formattedFromDate = spotFrom
      ? `${spotFrom.date()}-${spotFrom.month() + 1}-${spotFrom.year()}`
      : "";

    const formattedToDate = spotTo
      ? `${spotTo.date()}-${spotTo.month() + 1}-${spotTo.year()}`
      : "";

    if (!formattedFromDate || !formattedToDate) {
      sumfdt = "1" + "1" + selectYear;
      sumtdt = "31" + "12" + (parseInt(selectYear) + 1);
    } else {
      const from = dayjs(formattedFromDate);
      const to = dayjs(formattedToDate);

      fromDateStr = from.format("DD-MM-YYYY");
      toDateStr = to.format("DD-MM-YYYY");

      sumfdt = from.format("MMYYYY");
      sumtdt = to.format("MMYYYY");
    }

    // Special report ID
    if (reportArray === 6) {
      sumfdt = "0";
      sumtdt = "1";
    }

    if (spotTo && dayjs(spotFrom).isAfter(dayjs(spotTo))) {
      showToast("error", "From Date is greater than To Date");
      return;
    }
    if (spotFrom && dayjs(spotTo).isBefore(dayjs(spotFrom))) {
      showToast("error", "To Date is less than From Date");
      return;
    }

    try {
      // Main logic
      setIsSubmitting(true);
      if (reportArray !== 6) {
        const diff = handleReportDateDiff(formattedFromDate, formattedToDate);

        if (diff <= 7) {
          const response = await axios.get(
            `${REPORTSERVICE}viewRepotDetails/${usr}/${reportArray}/${formattedFromDate}/${formattedToDate}/2022/${page}/${country}`,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
            }
          );

          const result = response.data.ResultSet.body[0];
          console.log("rowcount", result["Row count"][0]);
          setDatastore(result.Header);
          setFundingHeader(result.Results);
          setSpotResultCount(result["Row count"][0]);
          setShowExportButton(true);
          setShowSpotReport(true);
          setShowFuturesReport(false);
          setShowOptionReport(false);

          const totalCount = result["Page count"][0];
          const pages = Array.from(
            { length: Math.ceil(totalCount) },
            (_, i) => i + 1
          );
          setPagiArr(pages);
          setPagiLength(pages.length);
        } else {
          const url = `${WEBSERVICE}report/viewRepotDetailsServer2/${usr}/${reportArray}/${formattedFromDate}/${formattedToDate}/2022/${country}?access_token=${token}`;
          setUrlForMailingReport(url);
          setDisclosureOpen(true);
        }
      } else {
        const url = `${WEBSERVICE}report/viewRepotDetailsServer2/${usr}/${reportArray}/0/0/${selectYear}/${country}?access_token=${token}`;
        setUrlForMailingReport(url);
        setDisclosureOpen(true);
      }

      // Download link setup
      const downloadUrl =
        reportArray !== 6
          ? `${REPORTSERVICE}viewRepotDetails/${usr}/${reportArray}/${formattedFromDate}/${formattedToDate}/2022/${country}?access_token=${token}`
          : `${REPORTSERVICE}viewRepotDetails/${usr}/${reportArray}/0/0/${selectYear}/${country}?access_token=${token}`;
      setDownloadUrl(downloadUrl);
    } catch (err) {
      showToast("error", "Error fetching report details");
      setIsSubmitting(false);
    }

    setIsSubmitting(false);
  };

  const fetchFuturesReport = async (pageNo) => {
    const usr = localStorage.getItem("uuid");
    const token = localStorage.getItem("access_token");
    const page = pageNo !== 0 ? pageNo : 1;
    setCurrentPage(page);

    const reportId = futuresReport;
    setSelectedFuturesReport(reportId);

    let fromDateStr = "",
      toDateStr = "",
      fsumfdt = "",
      fsumtdt = "";

    const formattedFromDate = futuresFrom
      ? `${futuresFrom.date()}-${futuresFrom.month() + 1}-${futuresFrom.year()}`
      : "";

    const formattedToDate = futuresTo
      ? `${futuresTo.date()}-${futuresTo.month() + 1}-${futuresTo.year()}`
      : "";

    if (!formattedFromDate || !formattedToDate) {
      fsumfdt = "1" + "1" + futuresYear;
      fsumtdt = "31" + "12" + (parseInt(futuresYear) + 1);
    } else {
      const from = dayjs(formattedFromDate);
      const to = dayjs(formattedToDate);

      fromDateStr = from.format("DD-MM-YYYY");
      toDateStr = to.format("DD-MM-YYYY");

      fsumfdt = from.format("MMYYYY");
      fsumtdt = to.format("MMYYYY");
    }

    // Report ID 2 is special: no date needed
    if (reportId === 2 || reportId === "2") {
      fsumfdt = "0";
      fsumtdt = "1";
    }

    // Validate date range

    if (toDate && dayjs(fromDate).isAfter(dayjs(toDate))) {
      showToast("error", "From Date is greater than To Date");
      return;
    }
    if (fromDate && dayjs(toDate).isBefore(dayjs(fromDate))) {
      showToast("error", "To Date is less than From Date");
      return;
    }

    try {
      setIsSubmittingFutures(true);
      if (reportId !== 2 && reportId !== "2") {
        const diff = handleReportDateDiff(formattedFromDate, formattedToDate);

        if (diff <= 7) {
          const url = `${REPORTSERVICE}viewFuturesRepotDetails/${usr}/${reportId}/${formattedFromDate}/${formattedToDate}/0/${page}/${country}`;
          const response = await axios.get(url, {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          });

          const data = response.data?.ResultSet?.body[0];
          setFuturesHeader(data.Header);
          setFuturesResults(data.Results);
          setTotalCount(data["Page count"][0]);
          setFutureResultCount(data["Page count"][0]);
          setFuturesPagination(
            [...Array(Math.ceil(data["Page count"][0])).keys()].map(
              (i) => i + 1
            )
          );

          setShowExportButton(false);
          setShowFuturesExportButton(true);
          setShowFuturesReport(true);
          setShowSpotReport(false);
          setShowOptionsReport(false);
        } else {
          const url = `${WEBSERVICE}report/viewFuturesRepotDetailsServer2/${usr}/${reportId}/${formattedFromDate}/${formattedToDate}/0/${country}?access_token=${token}`;
          setUrlForMailingReport(url);
          setDisclosureOpen(true);
        }
      } else {
        const url = `${WEBSERVICE}report/viewFuturesRepotDetailsServer2/${usr}/${reportId}/0/0/${futuresYear}/${country}?access_token=${token}`;
        setUrlForMailingReport(url);
        setDisclosureOpen(true);
      }

      // Set download URL for export
      const downloadUrl =
        reportId !== 2 && reportId !== "2"
          ? `${REPORTSERVICE}viewFuturesRepotDetails/${usr}/${reportId}/${formattedFromDate}/${formattedToDate}/0/${country}?access_token=${token}`
          : `${REPORTSERVICE}viewFuturesRepotDetails/${usr}/${reportId}/0/0/${futuresYear}/${country}?access_token=${token}`;
      setFuturesDownloadUrl(downloadUrl);
    } catch (err) {
      console.error("Error fetching futures report:", err);
      showToast("error", "Error fetching futures report");

      setIsSubmittingFutures(false);
    }
    setIsSubmittingFutures(false);
  };

  const fetchOptionsReport = async (pageNo = 1) => {
    const usr = localStorage.getItem("uuid");
    const token = localStorage.getItem("access_token");
    const page = pageNo !== 0 ? pageNo : 1;
    setCurrentPage(page);

    const reportId = optionsReport;
    setSelectedOptionsReport(reportId);

    let fromDateStr = "",
      toDateStr = "",
      fsumfdt = "",
      fsumtdt = "";

    const formattedFromDate = optionsFrom
      ? `${optionsFrom.date()}-${optionsFrom.month() + 1}-${optionsFrom.year()}`
      : "";

    const formattedToDate = optionsTo
      ? `${optionsTo.date()}-${optionsTo.month() + 1}-${optionsTo.year()}`
      : "";

    if (!formattedFromDate || !formattedToDate) {
      fsumfdt = "1" + "1" + optionsYear;
      fsumtdt = "31" + "12" + (parseInt(optionsYear) + 1);
    } else {
      const from = dayjs(formattedFromDate);
      const to = dayjs(formattedToDate);

      fromDateStr = from.format("DD-MM-YYYY");
      toDateStr = to.format("DD-MM-YYYY");

      fsumfdt = from.format("MMYYYY");
      fsumtdt = to.format("MMYYYY");
    }

    if (reportId === 2 || reportId === "2") {
      fsumfdt = "0";
      fsumtdt = "1";
    }

    if (optionsTo && dayjs(optionsFrom).isAfter(dayjs(optionsTo))) {
      showToast("error", "From Date is greater than To Date");
      return;
    }
    if (optionsFrom && dayjs(optionsTo).isBefore(dayjs(optionsFrom))) {
      showToast("error", "To Date is less than From Date");
      return;
    }

    try {
      setIsSubmittingOptions(true);
      if (reportId !== 2 && reportId !== "2") {
        const diff = handleReportDateDiff(formattedFromDate, formattedToDate);

        if (diff <= 7) {
          const url = `${REPORTSERVICE}viewOptionsRepotDetails/${usr}/${reportId}/${formattedFromDate}/${formattedToDate}/0/${page}/${country}`;
          const response = await axios.get(url, {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          });

          const data = response.data?.ResultSet?.body[0];
          setOptionsHeader(data.Header);
          setOptionsResults(data.Results);
          setTotalCount(data["Page count"][0]);
          setOptionResultCount(data["Page count"][0]);
          setOptionsPagination(
            [...Array(Math.ceil(data["Page count"][0])).keys()].map(
              (i) => i + 1
            )
          );

          setShowExportButton(false);
          setShowFuturesReport(false);
          setShowSpotReport(false);
          setShowOptionsExportButton(true);
          setShowOptionsReport(true);
        } else {
          const url = `${WEBSERVICE}report/viewOptionsRepotDetailsServer2/${usr}/${reportId}/${formattedFromDate}/${formattedToDate}/0/${country}?access_token=${token}`;
          setUrlForMailingReport(url);
          setDisclosureOpen(true);
        }
      } else {
        const url = `${WEBSERVICE}report/viewOptionsReportDetailsServer2/${usr}/${reportId}/0/0/${optionsYear}/${country}`;
        setUrlForMailingReport(url);
        setDisclosureOpen(true);
      }

      // Set download URL
      const downloadUrl =
        reportId !== 2 && reportId !== "2"
          ? `${REPORTSERVICE}viewOptionsRepotDetails/${usr}/${reportId}/${formattedFromDate}/${formattedToDate}/0/${country}?access_token=${token}`
          : `${REPORTSERVICE}viewOptionsRepotDetails/${usr}/${reportId}/0/0/${optionsYear}/${country}?access_token=${token}`;
      setOptionsDownloadUrl(downloadUrl);
    } catch (err) {
      console.error("Error fetching options report:", err);
      showToast("error", "Error fetching options report");
      setIsSubmittingOptions(false);
    }

    setIsSubmittingOptions(false);
  };

  const handleReportForSendingViaEmail = async (url) => {
    try {
      const token = localStorage.getItem("access_token");
      const response = await axios.get(url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      setResultOpen(true); // Open the result modal
    } catch (error) {
      console.error("Error sending report:", error);
      // Optionally show error toast/snackbar
    }
  };

  const handleExportClick = async (type) => {
    let exportUrl = "";

    switch (type) {
      case "spot":
        exportUrl = downloadUrl; // replace with actual
        break;
      case "futures":
        exportUrl = futuresDownloadUrl;
        break;
      case "options":
        exportUrl = optionsDownloadUrl;
        break;
      default:
        return;
    }

    // Trigger file download
    // const link = document.createElement("a");
    // link.href = exportUrl;
    // link.setAttribute("download", "report.csv"); // Hint for download
    // link.setAttribute("target", "_blank"); // Optional: open in new tab
    // document.body.appendChild(link);
    // link.click();
    // document.body.removeChild(link);

    try {
      const response = await fetch(exportUrl);

      if (!response.ok) {
        throw new Error(`Error ${response.status}: ${response.statusText}`);
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "report.csv");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Download failed:", error);
      alert("Download failed. Please check your API and token.");
    }
  };

  const tabsMeta = [
    {
      value: "spot",
      label: "Spot",
      icon: <ShowChartOutlinedIcon sx={{ fontSize: 18 }} />,
      caption: "Trade history & statements",
      count: spotResultCount,
      visible: showSpotReport,
    },
    {
      value: "futures",
      label: "Futures",
      icon: <TimelineOutlinedIcon sx={{ fontSize: 18 }} />,
      caption: "Position, margin & PnL",
      count: futureResultCount,
      visible: showFuturesReport,
      permission: brokerMarkets?.isFutures === 1,
    },
    {
      value: "options",
      label: "Options",
      icon: <CandlestickChartOutlinedIcon sx={{ fontSize: 18 }} />,
      caption: "Premium & expiry data",
      count: optionResultCount,
      visible: showOptionsReport,
      permission: brokerMarkets?.isOptions === 1,
    },
  ].filter((t) => t.permission !== false);

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box sx={pageWrapper}>
        {/* Hero Banner */}
        <Box
          sx={{
            ...heroBanner,
            background: `linear-gradient(135deg, ${alpha(
              btncolor || "#1976d2",
              0.95
            )} 0%, ${alpha(btncolor || "#1976d2", 0.75)} 100%)`,
          }}
        >
          <Box sx={heroContent}>
            <Box sx={heroIconBadge}>
              <AssessmentOutlinedIcon sx={{ color: "#fff", fontSize: 30 }} />
            </Box>
            <Box>
              <Typography sx={heroTitle}>Trading Reports</Typography>
              <Typography sx={heroSubtitle}>
                Generate, preview and export detailed reports for your Spot,
                Futures and Options activity
              </Typography>
            </Box>
          </Box>
        </Box>

        {/* Stats Strip */}
        {/* <Box sx={statsStrip}>
          {tabsMeta.map((t, i) => (
            <Box
              key={i}
              sx={{
                ...statCard,
                borderColor: activeTab === i ? btncolor : "rgba(0,0,0,0.08)",
                cursor: "pointer",
              }}
              onClick={() => setActiveTab(i)}
            >
              <Box sx={{ ...statIconWrap, backgroundColor: alpha(btncolor || "#1976d2", 0.1), color: btncolor }}>
                {t.icon}
              </Box>
              <Box sx={{ flex: 1, minWidth: 0 }}>
                <Typography sx={statLabel}>{t.label} Reports</Typography>
                <Typography sx={statCaption}>{t.caption}</Typography>
              </Box>
              <Box sx={statValueWrap}>
                <Typography sx={statValue}>{t.visible ? t.count || 0 : "—"}</Typography>
                <Typography sx={statValueLabel}>records</Typography>
              </Box>
            </Box>
          ))}
        </Box> */}

        {/* Main Card with Tabs */}
        <Box sx={mainCard}>
          <Box sx={tabsWrap}>
            <Tabs
              value={activeTab}
              onChange={(e, v) => setActiveTab(v)}
              variant="scrollable"
              scrollButtons="auto"
              sx={{
                ...tabsStyle,
                "& .MuiTabs-indicator": {
                  backgroundColor: btncolor,
                  height: 3,
                  borderRadius: "3px 3px 0 0",
                },
                "& .Mui-selected": { color: `${btncolor} !important` },
              }}
            >
              {tabsMeta.map((t) => (
                <Tab
                  key={t.value}
                  value={t.value}
                  iconPosition="start"
                  icon={t.icon}
                  label={`${t.label} Reports`}
                  sx={tabItem}
                />
              ))}
            </Tabs>
          </Box>

          {/* SPOT TAB */}
          {activeTab === "spot" && (
            <Box>
              <Box sx={filterCard}>
                <Box sx={filterHeader}>
                  <FilterAltOutlinedIcon
                    sx={{ ...filterHeaderIcon, color: btncolor }}
                  />
                  <Typography sx={filterHeaderText}>
                    Filter Spot Report
                  </Typography>
                </Box>
                <Box sx={filterGrid}>
                  <Box sx={fieldWrap}>
                    <Typography sx={fieldLabel}>
                      <DescriptionOutlinedIcon sx={fieldLabelIcon} /> Report
                      Type
                    </Typography>
                    <TextField
                      select
                      placeholder="Select report"
                      value={selectedSpotReport}
                      onChange={(e) => setSelectedSpotReport(e.target.value)}
                      sx={modernFieldStyle}
                      fullWidth
                    >
                      {spotReportList.map((report, index) => (
                        <MenuItem key={index} value={report.ID}>
                          {report.VIEW_NAME_SHOW}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Box>

                  {selectedSpotReport == 6 ? (
                    <Box sx={fieldWrap}>
                      <Typography sx={fieldLabel}>
                        <EventOutlinedIcon sx={fieldLabelIcon} /> Financial Year
                      </Typography>
                      <TextField
                        select
                        value={spotFinancialYear}
                        onChange={(e) => (
                          setSpotFinancialYear(e.target.value),
                          setSelectYear(e.target.value)
                        )}
                        sx={modernFieldStyle}
                        fullWidth
                      >
                        {spotFinancialYearReportList.map((year, index) => (
                          <MenuItem key={index} value={year.YEAR}>
                            {year.FINANCIAL_YEAR}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Box>
                  ) : (
                    <>
                      <Box sx={fieldWrap}>
                        <Typography sx={fieldLabel}>
                          <EventOutlinedIcon sx={fieldLabelIcon} /> From Date
                        </Typography>
                        <DatePicker
                          value={spotFrom}
                          onChange={setSpotFrom}
                          maxDate={dayjs()}
                          slotProps={{
                            textField: {
                              sx: modernFieldStyle,
                              fullWidth: true,
                            },
                          }}
                        />
                      </Box>
                      <Box sx={fieldWrap}>
                        <Typography sx={fieldLabel}>
                          <EventOutlinedIcon sx={fieldLabelIcon} /> To Date
                        </Typography>
                        <DatePicker
                          value={spotTo}
                          minDate={spotFrom}
                          maxDate={dayjs()}
                          onChange={setSpotTo}
                          slotProps={{
                            textField: {
                              sx: modernFieldStyle,
                              fullWidth: true,
                            },
                          }}
                        />
                      </Box>
                    </>
                  )}

                  <Box sx={submitWrap}>
                    <ContainedButton
                      variant="contained"
                      sx={modernSubmitStyle}
                      onClick={(e) => findData(1)}
                      disabled={isSubmitting}
                      fullWidth
                    >
                      {isSubmitting ? (
                        <CircularProgress size={20} sx={{ color: "#000" }} />
                      ) : (
                        "Generate Report"
                      )}
                    </ContainedButton>
                  </Box>
                </Box>
              </Box>

              {showSpotReport && (
                <Box sx={resultsBlock}>
                  <Box sx={resultsHeader}>
                    <Box>
                      <Typography sx={resultsTitle}>
                        Spot Report Results
                      </Typography>
                      <Typography sx={resultsCaption}>
                        Showing {fundingHeader?.length || 0} of{" "}
                        {spotResultCount || 0} entries
                      </Typography>
                    </Box>
                    <Tooltip title="Export as CSV" arrow>
                      <Button
                        onClick={() => handleExportClick("spot")}
                        sx={{
                          ...modernExportBtn,
                          backgroundColor: btncolor,
                          "&:hover": {
                            backgroundColor: btncolor,
                            opacity: 0.9,
                          },
                        }}
                        startIcon={<FileDownloadOutlinedIcon />}
                      >
                        Export CSV
                      </Button>
                    </Tooltip>
                  </Box>

                  <TableContainer component={Paper} sx={modernTableContainer}>
                    <Table sx={tableStyle}>
                      <TableHead>
                        <TableRow sx={modernTableHeadRow}>
                          {datastore.map((header, idx) => (
                            <TableCell key={idx} sx={modernTableHeadCell}>
                              {header}
                            </TableCell>
                          ))}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {fundingHeader?.length > 0 ? (
                          fundingHeader.map((row, rowIndex) => (
                            <TableRow key={rowIndex} sx={modernTableBodyRow}>
                              {datastore.map((header, colIndex) => (
                                <TableCell
                                  key={colIndex}
                                  sx={modernTableBodyCell}
                                >
                                  {selectedSpotReport == 4 &&
                                  (header === "AMOUNT" || header === "GST")
                                    ? Number(row[colIndex])?.toFixed(6)
                                    : row[colIndex]}
                                </TableCell>
                              ))}
                            </TableRow>
                          ))
                        ) : (
                          <TableRow>
                            <TableCell
                              colSpan={datastore.length}
                              sx={emptyCell}
                            >
                              <InboxOutlinedIcon sx={emptyIcon} />
                              <Typography sx={emptyText}>
                                No records found
                              </Typography>
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                    <TablePagination
                      rowsPerPageOptions={[]}
                      component="div"
                      count={spotResultCount}
                      rowsPerPage={spotRowsPerPage}
                      page={spotPage}
                      onPageChange={handleSpotPageChange}
                      sx={paginationStyle}
                    />
                  </TableContainer>
                </Box>
              )}
            </Box>
          )}

          {/* FUTURES TAB */}
          {activeTab === "futures" && (
            <Box sx={tabPanel}>
              <Box sx={filterCard}>
                <Box sx={filterHeader}>
                  <FilterAltOutlinedIcon
                    sx={{ ...filterHeaderIcon, color: btncolor }}
                  />
                  <Typography sx={filterHeaderText}>
                    Filter Futures Report
                  </Typography>
                </Box>
                <Box sx={filterGrid}>
                  <Box sx={fieldWrap}>
                    <Typography sx={fieldLabel}>
                      <DescriptionOutlinedIcon sx={fieldLabelIcon} /> Report
                      Type
                    </Typography>
                    <TextField
                      select
                      value={futuresReport}
                      onChange={(e) => setFuturesReport(e.target.value)}
                      sx={modernFieldStyle}
                      fullWidth
                    >
                      {futuresReportList.map((report, index) => (
                        <MenuItem key={index} value={report.id}>
                          {report.reportName}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Box>

                  {futuresReport === 2 ? (
                    <Box sx={fieldWrap}>
                      <Typography sx={fieldLabel}>
                        <EventOutlinedIcon sx={fieldLabelIcon} /> Financial Year
                      </Typography>
                      <TextField
                        select
                        value={futureFinancialYear}
                        onChange={(e) => (
                          setFutureFinancialYear(e.target.value),
                          setFuturesYear(e.target.value)
                        )}
                        sx={modernFieldStyle}
                        fullWidth
                      >
                        {spotFinancialYearReportList.map((year, index) => (
                          <MenuItem key={index} value={year.YEAR}>
                            {year.FINANCIAL_YEAR}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Box>
                  ) : (
                    <>
                      <Box sx={fieldWrap}>
                        <Typography sx={fieldLabel}>
                          <EventOutlinedIcon sx={fieldLabelIcon} /> From Date
                        </Typography>
                        <DatePicker
                          value={futuresFrom}
                          maxDate={dayjs()}
                          onChange={setFuturesFrom}
                          slotProps={{
                            textField: {
                              sx: modernFieldStyle,
                              fullWidth: true,
                            },
                          }}
                        />
                      </Box>
                      <Box sx={fieldWrap}>
                        <Typography sx={fieldLabel}>
                          <EventOutlinedIcon sx={fieldLabelIcon} /> To Date
                        </Typography>
                        <DatePicker
                          value={futuresTo}
                          minDate={futuresFrom}
                          maxDate={dayjs()}
                          onChange={setFuturesTo}
                          slotProps={{
                            textField: {
                              sx: modernFieldStyle,
                              fullWidth: true,
                            },
                          }}
                        />
                      </Box>
                    </>
                  )}

                  <Box sx={submitWrap}>
                    <ContainedButton
                      variant="contained"
                      sx={modernSubmitStyle}
                      onClick={(e) => fetchFuturesReport(1)}
                      disabled={isSubmittingFutures}
                      fullWidth
                    >
                      {isSubmittingFutures ? (
                        <CircularProgress size={20} sx={{ color: "#000" }} />
                      ) : (
                        "Generate Report"
                      )}
                    </ContainedButton>
                  </Box>
                </Box>
              </Box>

              {showFuturesReport && (
                <Box sx={resultsBlock}>
                  <Box sx={resultsHeader}>
                    <Box>
                      <Typography sx={resultsTitle}>
                        Futures Report Results
                      </Typography>
                      <Typography sx={resultsCaption}>
                        Showing {futuresResults?.length || 0} of{" "}
                        {futureResultCount || 0} entries
                      </Typography>
                    </Box>
                    <Tooltip title="Export as CSV" arrow>
                      <Button
                        onClick={() => handleExportClick("futures")}
                        sx={{
                          ...modernExportBtn,
                          backgroundColor: btncolor,
                          "&:hover": {
                            backgroundColor: btncolor,
                            opacity: 0.9,
                          },
                        }}
                        startIcon={<FileDownloadOutlinedIcon />}
                      >
                        Export CSV
                      </Button>
                    </Tooltip>
                  </Box>

                  <TableContainer component={Paper} sx={modernTableContainer}>
                    <Table sx={tableStyle}>
                      <TableHead>
                        <TableRow sx={modernTableHeadRow}>
                          {futuresHeader.map((header, idx) => (
                            <TableCell key={idx} sx={modernTableHeadCell}>
                              {header}
                            </TableCell>
                          ))}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {futuresResults?.length > 0 ? (
                          futuresResults.map((row, rowIndex) => (
                            <TableRow key={rowIndex} sx={modernTableBodyRow}>
                              {futuresHeader.map((header, colIndex) => (
                                <TableCell
                                  key={colIndex}
                                  sx={modernTableBodyCell}
                                >
                                  {header === "INITIAL MARGIN"
                                    ? Number(row[colIndex]).toFixed(6)
                                    : row[colIndex]}
                                </TableCell>
                              ))}
                            </TableRow>
                          ))
                        ) : (
                          <TableRow>
                            <TableCell
                              colSpan={futuresHeader.length}
                              sx={emptyCell}
                            >
                              <InboxOutlinedIcon sx={emptyIcon} />
                              <Typography sx={emptyText}>
                                No records found
                              </Typography>
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                    <TablePagination
                      rowsPerPageOptions={[]}
                      component="div"
                      count={futureResultCount}
                      rowsPerPage={futuresRowsPerPage}
                      page={futuresPage}
                      onPageChange={handleFuturesPageChange}
                      sx={paginationStyle}
                    />
                  </TableContainer>
                </Box>
              )}
            </Box>
          )}

          {/* OPTIONS TAB */}
          {activeTab === "options" && (
            <Box sx={tabPanel}>
              <Box sx={filterCard}>
                <Box sx={filterHeader}>
                  <FilterAltOutlinedIcon
                    sx={{ ...filterHeaderIcon, color: btncolor }}
                  />
                  <Typography sx={filterHeaderText}>
                    Filter Options Report
                  </Typography>
                </Box>
                <Box sx={filterGrid}>
                  <Box sx={fieldWrap}>
                    <Typography sx={fieldLabel}>
                      <DescriptionOutlinedIcon sx={fieldLabelIcon} /> Report
                      Type
                    </Typography>
                    <TextField
                      select
                      value={optionsReport}
                      onChange={(e) => setOptionsReport(e.target.value)}
                      sx={modernFieldStyle}
                      fullWidth
                    >
                      {optionsReportList.map((report, index) => (
                        <MenuItem key={index} value={report.id}>
                          {report.reportName}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Box>

                  {optionsReport === 2 ? (
                    <Box sx={fieldWrap}>
                      <Typography sx={fieldLabel}>
                        <EventOutlinedIcon sx={fieldLabelIcon} /> Financial Year
                      </Typography>
                      <TextField
                        select
                        value={futureFinancialYear}
                        onChange={(e) => (
                          setFutureFinancialYear(e.target.value),
                          setOptionsYear(e.target.value)
                        )}
                        sx={modernFieldStyle}
                        fullWidth
                      >
                        {spotFinancialYearReportList.map((year, index) => (
                          <MenuItem key={index} value={year.YEAR}>
                            {year.FINANCIAL_YEAR}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Box>
                  ) : (
                    <>
                      <Box sx={fieldWrap}>
                        <Typography sx={fieldLabel}>
                          <EventOutlinedIcon sx={fieldLabelIcon} /> From Date
                        </Typography>
                        <DatePicker
                          value={optionsFrom}
                          maxDate={dayjs()}
                          onChange={setOptionsFrom}
                          slotProps={{
                            textField: {
                              sx: modernFieldStyle,
                              fullWidth: true,
                            },
                          }}
                        />
                      </Box>
                      <Box sx={fieldWrap}>
                        <Typography sx={fieldLabel}>
                          <EventOutlinedIcon sx={fieldLabelIcon} /> To Date
                        </Typography>
                        <DatePicker
                          value={optionsTo}
                          minDate={optionsFrom}
                          maxDate={dayjs()}
                          onChange={setOptionsTo}
                          slotProps={{
                            textField: {
                              sx: modernFieldStyle,
                              fullWidth: true,
                            },
                          }}
                        />
                      </Box>
                    </>
                  )}

                  <Box sx={submitWrap}>
                    <ContainedButton
                      variant="contained"
                      sx={modernSubmitStyle}
                      onClick={(e) => fetchOptionsReport()}
                      disabled={isSubmittingOptions}
                      fullWidth
                    >
                      {isSubmittingOptions ? (
                        <CircularProgress size={20} sx={{ color: "#000" }} />
                      ) : (
                        "Generate Report"
                      )}
                    </ContainedButton>
                  </Box>
                </Box>
              </Box>

              {showOptionsReport && (
                <Box sx={resultsBlock}>
                  <Box sx={resultsHeader}>
                    <Box>
                      <Typography sx={resultsTitle}>
                        Options Report Results
                      </Typography>
                      <Typography sx={resultsCaption}>
                        Showing {optionsResults?.length || 0} of{" "}
                        {optionResultCount || 0} entries
                      </Typography>
                    </Box>
                    <Tooltip title="Export as CSV" arrow>
                      <Button
                        onClick={() => handleExportClick("options")}
                        sx={{
                          ...modernExportBtn,
                          backgroundColor: btncolor,
                          "&:hover": {
                            backgroundColor: btncolor,
                            opacity: 0.9,
                          },
                        }}
                        startIcon={<FileDownloadOutlinedIcon />}
                      >
                        Export CSV
                      </Button>
                    </Tooltip>
                  </Box>

                  <TableContainer component={Paper} sx={modernTableContainer}>
                    <Table sx={tableStyle}>
                      <TableHead>
                        <TableRow sx={modernTableHeadRow}>
                          {optionsHeader.map((header, idx) => (
                            <TableCell key={idx} sx={modernTableHeadCell}>
                              {header}
                            </TableCell>
                          ))}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {optionsResults?.length > 0 ? (
                          optionsResults.map((row, rowIndex) => (
                            <TableRow key={rowIndex} sx={modernTableBodyRow}>
                              {optionsHeader.map((header, colIndex) => (
                                <TableCell
                                  key={colIndex}
                                  sx={modernTableBodyCell}
                                >
                                  {row[colIndex]}
                                </TableCell>
                              ))}
                            </TableRow>
                          ))
                        ) : (
                          <TableRow>
                            <TableCell
                              colSpan={optionsHeader.length}
                              sx={emptyCell}
                            >
                              <InboxOutlinedIcon sx={emptyIcon} />
                              <Typography sx={emptyText}>
                                No records found
                              </Typography>
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                    <TablePagination
                      rowsPerPageOptions={[]}
                      component="div"
                      count={optionResultCount}
                      rowsPerPage={25}
                      page={optionsPage}
                      onPageChange={handleOptionsPageChange}
                      sx={paginationStyle}
                    />
                  </TableContainer>
                </Box>
              )}
            </Box>
          )}
        </Box>
      </Box>

      {/* === Disclosure Modal === */}
      <Dialog
        open={disclosureOpen}
        onClose={() => setDisclosureOpen(false)}
        PaperProps={{ sx: dialogPaper }}
      >
        <DialogTitle sx={dialogTitleStyle}>Reports</DialogTitle>
        <Divider />
        <DialogContent sx={dialogContentStyle}>
          <Typography sx={dialogText}>
            Report data over seven days will be sent to your registered email.
          </Typography>
          <DialogActions sx={dialogActionsStyle}>
            <ContainedButton
              variant="contained"
              sx={{ mx: 1, minWidth: 110 }}
              onClick={() => {
                setDisclosureOpen(false);
                handleReportForSendingViaEmail(urlForMailingReport);
              }}
            >
              Proceed
            </ContainedButton>
            <ContainedButton
              variant="contained"
              sx={{ mx: 1, minWidth: 110 }}
              onClick={() => setDisclosureOpen(false)}
            >
              Cancel
            </ContainedButton>
          </DialogActions>
        </DialogContent>
      </Dialog>

      {/* === Result Modal === */}
      <Dialog
        open={resultOpen}
        onClose={() => setResultOpen(false)}
        PaperProps={{ sx: dialogPaper }}
      >
        <DialogTitle sx={dialogTitleStyle}>Reports</DialogTitle>
        <Divider />
        <DialogContent sx={dialogContentStyle}>
          <Typography sx={dialogText}>
            The data will be sent to your registered email within 15 minutes.
          </Typography>
          <DialogActions sx={dialogActionsStyle}>
            <ContainedButton
              variant="contained"
              sx={{ mx: 1, minWidth: 110 }}
              onClick={() => setResultOpen(false)}
            >
              Ok
            </ContainedButton>
          </DialogActions>
        </DialogContent>
      </Dialog>
    </LocalizationProvider>
  );
};

// 🎨 Theme-aware Styling (uses CSS variables defined in App.js)
const pageWrapper = {
  px: { xs: 2, md: 4 },
  py: { xs: 2, md: 3 },
  backgroundColor: "var(--body-color)",
  color: "var(--text-color)",
  minHeight: "calc(100vh - 64px)",
};

const heroBanner = {
  borderRadius: "18px",
  px: { xs: 3, md: 4 },
  py: { xs: 3, md: 3.5 },
  mb: 3,
  position: "relative",
  overflow: "hidden",
  boxShadow: "0 10px 30px rgba(0,0,0,0.18)",
};

const heroContent = {
  display: "flex",
  alignItems: "center",
  gap: 2,
  position: "relative",
  zIndex: 1,
};

const heroIconBadge = {
  width: 56,
  height: 56,
  borderRadius: "14px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "rgba(255,255,255,0.18)",
  border: "1px solid rgba(255,255,255,0.25)",
  backdropFilter: "blur(6px)",
};

const heroTitle = {
  fontSize: { xs: "1.4rem", md: "1.7rem" },
  fontWeight: 700,
  color: "#fff",
  lineHeight: 1.15,
  letterSpacing: "-0.015em",
};

const heroSubtitle = {
  fontSize: { xs: "0.82rem", md: "0.9rem" },
  color: "rgba(255,255,255,0.88)",
  mt: 0.5,
  maxWidth: 640,
};

const statsStrip = {
  display: "grid",
  gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr", md: "1fr 1fr 1fr" },
  gap: 2,
  mb: 3,
};

const statCard = {
  display: "flex",
  alignItems: "center",
  gap: 1.5,
  p: 2,
  backgroundColor: "var(--body-color-less)",
  border: "1.5px solid",
  borderRadius: "14px",
  transition: "all 0.2s ease",
  boxShadow: "0 1px 2px rgba(0,0,0,0.06)",
  "&:hover": {
    transform: "translateY(-1px)",
    boxShadow: "0 6px 16px rgba(0,0,0,0.10)",
  },
};

const statIconWrap = {
  width: 42,
  height: 42,
  borderRadius: "12px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
};

const statLabel = {
  fontSize: "0.9rem",
  fontWeight: 600,
  color: "var(--text-color)",
  lineHeight: 1.2,
};

const statCaption = {
  fontSize: "0.72rem",
  color: "var(--text-color)",
  opacity: 0.65,
  mt: 0.25,
};

const statValueWrap = {
  textAlign: "right",
  flexShrink: 0,
};

const statValue = {
  fontSize: "1.25rem",
  fontWeight: 700,
  lineHeight: 1,
  color: "var(--text-color)",
};

const statValueLabel = {
  fontSize: "0.65rem",
  textTransform: "uppercase",
  letterSpacing: "0.06em",
  color: "var(--text-color)",
  opacity: 0.6,
  mt: 0.25,
};

const mainCard = {
  backgroundColor: "var(--body-color-less)",
  borderRadius: "16px",
  border: "1px solid rgba(125,125,125,0.15)",
  boxShadow: "0 1px 3px rgba(0,0,0,0.06), 0 10px 25px rgba(0,0,0,0.06)",
  overflow: "hidden",
};

const tabsWrap = {
  borderBottom: "1px solid rgba(125,125,125,0.15)",
  px: { xs: 1, md: 2 },
  backgroundColor: "var(--body-color-less2)",
};

const tabsStyle = {
  minHeight: 56,
  "& .MuiTab-root": { minHeight: 56 },
};

const tabItem = {
  textTransform: "none",
  fontWeight: 600,
  fontSize: "0.9rem",
  color: "var(--text-color)",
  opacity: 0.65,
  letterSpacing: "0.01em",
  px: 2,
  gap: 0.75,
  "&.Mui-selected": { color: "var(--text-color)", opacity: 1 },
};

const tabPanel = {
  p: { xs: 2, md: 3 },
};

const filterCard = {
  // backgroundColor: "var(--body-color-less2)",
  // border: "1px solid rgba(125,125,125,0.15)",
  borderRadius: "12px",
  p: { xs: 2, md: 2.5 },
  mb: 3,
};

const filterHeader = {
  display: "flex",
  alignItems: "center",
  gap: 1,
  mb: 2,
};

const filterHeaderIcon = {
  fontSize: 18,
};

const filterHeaderText = {
  fontSize: "0.85rem",
  fontWeight: 600,
  color: "var(--text-color)",
  textTransform: "uppercase",
  letterSpacing: "0.06em",
};

const filterGrid = {
  display: "grid",
  gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr", md: "1fr 1fr 1fr auto" },
  gap: 2,
  alignItems: "end",
};

const fieldWrap = {
  display: "flex",
  flexDirection: "column",
  gap: 0.75,
  minWidth: 0,
};

const fieldLabel = {
  fontSize: "0.75rem",
  fontWeight: 600,
  color: "var(--text-color)",
  opacity: 0.7,
  textTransform: "uppercase",
  letterSpacing: "0.05em",
  display: "flex",
  alignItems: "center",
  gap: 0.5,
};

const fieldLabelIcon = {
  fontSize: 14,
  color: "var(--text-color)",
  opacity: 0.7,
};

const modernFieldStyle = {
  width: "100%",
  "& .MuiInputBase-root": {
    height: "48px",
    borderRadius: "10px",
    backgroundColor: "var(--body-color)",
    color: "var(--text-color)",
    fontSize: "0.9rem",
  },
  "& .MuiInputBase-input": { color: "var(--text-color)" },
  "& .MuiSelect-select": { color: "var(--text-color)" },
  "& .MuiSvgIcon-root": { color: "var(--text-color)", opacity: 0.7 },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "rgba(125,125,125,0.25)",
  },
  "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: "rgba(125,125,125,0.45)",
  },
  "& .MuiInputLabel-root": { display: "none" },
  "& legend": { display: "none" },
  "& fieldset": { top: 0 },
};

const submitWrap = {
  display: "flex",
  alignItems: "end",
  minWidth: { md: 160 },
};

const modernSubmitStyle = {
  height: "48px",
  px: 3,
  borderRadius: "10px",
  fontWeight: 600,
  fontSize: "0.85rem",
  textTransform: "none",
  letterSpacing: "0.01em",
  width: "100%",
  whiteSpace: "nowrap",
};

const resultsBlock = {
  mt: 1,
};

const resultsHeader = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  flexWrap: "wrap",
  gap: 1.5,
  mb: 2,
};

const resultsTitle = {
  fontSize: "1rem",
  fontWeight: 700,
  color: "var(--text-color)",
  lineHeight: 1.2,
};

const resultsCaption = {
  fontSize: "0.78rem",
  color: "var(--text-color)",
  opacity: 0.65,
  mt: 0.25,
};

const modernExportBtn = {
  color: "#fff",
  textTransform: "none",
  fontWeight: 600,
  fontSize: "0.82rem",
  px: 2,
  height: 40,
  borderRadius: "10px",
  boxShadow: "0 2px 6px rgba(0,0,0,0.18)",
};

const modernTableContainer = {
  borderRadius: "12px",
  border: "1px solid rgba(125,125,125,0.15)",
  boxShadow: "none",
  overflow: "hidden",
  backgroundColor: "var(--body-color-less)",
};

const tableStyle = {
  minWidth: 650,
};

const modernTableHeadRow = {
  backgroundColor: "var(--body-color-less2)",
};

const modernTableHeadCell = {
  fontWeight: 700,
  fontSize: "0.72rem",
  textTransform: "uppercase",
  letterSpacing: "0.06em",
  color: "var(--text-color)",
  opacity: 0.75,
  borderBottom: "1px solid rgba(125,125,125,0.15)",
  py: 1.75,
  whiteSpace: "nowrap",
};

const modernTableBodyRow = {
  transition: "background-color 0.15s ease",
  "&:hover": { backgroundColor: "var(--body-color-less2)" },
  "&:last-child td": { borderBottom: 0 },
};

const modernTableBodyCell = {
  fontSize: "0.85rem",
  py: 1.65,
  borderBottom: "1px solid rgba(125,125,125,0.12)",
  color: "var(--text-color)",
};

const emptyCell = {
  textAlign: "center",
  py: 7,
  borderBottom: 0,
};

const emptyIcon = {
  fontSize: 48,
  color: "var(--text-color)",
  opacity: 0.35,
  mb: 1,
};

const emptyText = {
  fontSize: "0.92rem",
  color: "var(--text-color)",
  opacity: 0.65,
};

const paginationStyle = {
  borderTop: "1px solid rgba(125,125,125,0.15)",
  backgroundColor: "var(--body-color-less2)",
  color: "var(--text-color)",
  "& .MuiTablePagination-toolbar": {
    minHeight: 52,
    color: "var(--text-color)",
  },
  "& .MuiTablePagination-displayedRows": {
    fontSize: "0.82rem",
    color: "var(--text-color)",
  },
  "& .MuiTablePagination-selectLabel": { color: "var(--text-color)" },
  "& .MuiSvgIcon-root": { color: "var(--text-color)" },
  "& .MuiIconButton-root.Mui-disabled .MuiSvgIcon-root": { opacity: 0.35 },
};

const dialogPaper = {
  borderRadius: "16px",
  minWidth: { xs: "85%", sm: 440 },
  boxShadow: "0 24px 60px rgba(0,0,0,0.28)",
  overflow: "hidden",
  backgroundColor: "var(--popupbody-color)",
  color: "var(--text-color)",
};

const dialogTitleStyle = {
  textAlign: "center",
  fontWeight: 700,
  fontSize: "1.15rem",
  py: 2.25,
  color: "var(--text-color)",
  backgroundColor: "var(--popupheader-color)",
};

const dialogContentStyle = {
  pt: 3,
  pb: 3,
  textAlign: "center",
  backgroundColor: "var(--popupbody-color)",
};

const dialogText = {
  fontSize: "0.95rem",
  color: "var(--text-color)",
  opacity: 0.85,
  lineHeight: 1.6,
};

const dialogActionsStyle = {
  justifyContent: "center",
  mt: 3,
  px: 0,
};

export default Report;
